import { render } from "./statbox.vue?vue&type=template&id=03f8ec72"
import script from "./statbox.vue?vue&type=script&lang=js"
export * from "./statbox.vue?vue&type=script&lang=js"

import "./statbox.vue?vue&type=style&index=0&id=03f8ec72&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__